import type { CSSProperties } from "react";
import { cn } from "@/lib/utils";

/** Decorative blurred gradient blob. Position/size/gradient are the caller's. */
export function GlowBackground({
	className,
	style,
}: {
	className?: string;
	style?: CSSProperties;
}) {
	return (
		<div
			className={cn(
				"jana-blob pointer-events-none absolute -z-10 rounded-full blur-3xl",
				className,
			)}
			style={style}
			aria-hidden
		/>
	);
}
